import React from 'react'
import { Helmet } from 'react-helmet-async'

interface SeoProps {
  title: string,
  description: string,
  noindex?: boolean
}

export default function SEO({title, description, noindex}: SeoProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description}/>
      {noindex && <meta name='robots' content='noindex, nofollow'/>}
    </Helmet>
  )
}
